// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"a356c6c8","596":"e58b9060"}[chunkId] + ".chunk.js";
};